module.exports = __webpack_public_path__ + "img/ion_document-outline.f78224e7.svg";